import { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { RatesAuthContext } from '../contexts/RatesAuthContext'

const RatesProtectedRoute = ({ children }) => {
  const { isRatesAuthenticated } = useContext(RatesAuthContext)

  if (!isRatesAuthenticated) {
    return <Navigate to="/reports" replace />
  }

  return children
}

export default RatesProtectedRoute
